import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  REQUEST_CERTIFICATE,
  REQUEST_CERTIFICATE_FAILURE,
  REQUEST_CERTIFICATE_SUCCESS,
} from '../constants/ActionTypes';

import { STRING, DATE } from '../constants/DataTypes';
import { fields, detailFields, entityMap } from '../constants/fields/EmployeeMasterCertificate';
import convert from '../utils/dateTools';

export function mapCertificate(c) {
  return {
    fields,
    detailFields,
    entityMap,
    Entity: c.Entity,
    CertificateName: {
      label: <div><FormattedMessage id="certificate.name" /></div>,
      value: c.CertificateName,
      type: STRING,
      entity: 'HrCertificateID',
    },
    CertificateTypeName: {
      label: <div><FormattedMessage id="certificate.type" /></div>,
      value: c.CertificateTypeName,
      type: STRING,
      entity: 'CertificateType',
    },
    CertificatePeriodBegda: {
      label: <div><FormattedMessage id="certificate.from" /></div>,
      value: convert(c.CertificatePeriodBegda),
      type: DATE,
      entity: 'CertificatePeriodBegda',
    },
    CertificatePeriodEnda: {
      label: <div><FormattedMessage id="certificate.to" /></div>,
      value: convert(c.CertificatePeriodEnda),
      type: DATE,
      entity: 'CertificatePeriodEnda',
    },
  };
}

export default function careerReducer(state = {}, action) {
  switch (action.type) {
    case REQUEST_CERTIFICATE:
      return {
        ...state,
        isFetching: true,
        loaded: false,
        certificateData: [],
      };

    case REQUEST_CERTIFICATE_FAILURE:
      return {
        ...state,
        isFetching: false,
        loaded: true,
        certificateData: [],
        error: action.error,
      };

    case REQUEST_CERTIFICATE_SUCCESS: {
      return {
        ...state,
        isFetching: false,
        lastUpdated: action.receivedAt,
        loaded: true,
        certificateData: action.certificateList.map(mapCertificate),
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/certificateReducer.js